/**
 * @generated SignedSource<<cece3d7073eeb2a113f09092aa92ed6c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NovaAgentShape = "SINGLE_OUTPUT" | "CONVERSATIONAL" | "%future added value";
export type UpdateNovaAgentInput = {
  id: string;
  name: string;
  categoryId: string;
  title: string;
  description: string;
  shape?: NovaAgentShape | null;
  systemPrompt?: string | null;
  userPromptTemplate?: string | null;
  agentMd?: string | null;
  model?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type UpdateNovaAgentMutation$variables = {
  input: UpdateNovaAgentInput;
};
export type UpdateNovaAgentMutation$data = {
  readonly updateNovaAgent: {
    readonly agent: {
      readonly id: string;
      readonly name: string | null;
      readonly title: string | null;
      readonly description: string | null;
      readonly categoryId: string | null;
    } | null;
  } | null;
};
export type UpdateNovaAgentMutation = {
  variables: UpdateNovaAgentMutation$variables;
  response: UpdateNovaAgentMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNovaAgentPayload",
    "kind": "LinkedField",
    "name": "updateNovaAgent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "categoryId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateNovaAgentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateNovaAgentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "553723569a60f881a23edff226d95af4",
    "id": null,
    "metadata": {},
    "name": "UpdateNovaAgentMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateNovaAgentMutation(\n  $input: UpdateNovaAgentInput!\n) {\n  updateNovaAgent(input: $input) {\n    agent {\n      id\n      name\n      title\n      description\n      categoryId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6bca2b83e760946f1bf58e8fb351aff1";

export default node;
